export default __webpack_public_path__ + "static/media/phone.inline.a5cf48d9.svg";